import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './scss/style.scss';

import ChromeIcon   from '../../../icons/ChromeIcon';
import EdgeIcon     from '../../../icons/EdgeIcon';
import ExplorerIcon from '../../../icons/ExplorerIcon';
import FirefoxIcon  from '../../../icons/FirefoxIcon';
import OperaIcon    from '../../../icons/OperaIcon';
import SafariIcon   from '../../../icons/SafariIcon';

const FooterCookieBrowsersLinks = () => {
  const { t } = useTranslation();

  const cookieManagementLinks = useMemo(() => {
    return [
      {
        icon: <FirefoxIcon />,
        link: 'https://support.mozilla.org/ru/kb/udalenie-kukov-dlya-udaleniya-informacii-kotoruyu-',
      },
      {
        icon: <ChromeIcon />,
        link: 'https://support.google.com/chrome/answer/95647',
      },
      {
        icon: <SafariIcon />,
        link: 'https://support.apple.com/ru-ru/guide/safari/sfri11471/mac',
      },
      {
        icon: <OperaIcon />,
        link: 'https://help.opera.com/ru/latest/web-preferences/#%D0%A3%D0%BF%D1%80%D0%B0%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5-%D1%84%D0%B0%D0%B9%D0%BB%D0%B0%D0%BC%D0%B8-cookie',
      },
      {
        icon: <EdgeIcon />,
        link: 'https://support.microsoft.com/ru-ru/microsoft-edge/%20%D1%83%D0%B4%D0%B0%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2-cookie-%D0%B2-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09',
      },
      {
        icon: <ExplorerIcon />,
        link: 'https://support.microsoft.com/ru-ru/topic/%D0%BE%D0%BF%D0%B8%D1%81%D0%B0%D0%BD%D0%B8%D0%B5-%D1%84%D0%B0%D0%B9%D0%BB%D0%BE%D0%B2-cookie-ad01aa7e-66c9-8ab2-7898-6652c100999d',
      },
    ];
  }, []);

  return (
    <div className={'browser_links_container'}>
      <p className={'browser_links_description'}>{t('client_browser_cookie')}</p>
      <div className={'browser_links_wrapper'}>
        {cookieManagementLinks.map((link, index) =>
          <a
            href={link.link}
            key={index}
            rel={'nofollow noindex noreferrer'}
            target={'_blank'}
          >
            {link.icon}
          </a>)}
      </div>
    </div>
  );
};

export default FooterCookieBrowsersLinks;